import React from 'react';
import { GenericListPage } from '../../components/generic';
import { usePayees, Payee } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../contexts/ThemeContext';

const List: React.FC = () => {
  const { colors } = useTheme();
  return (
    <GenericListPage<Payee>
      useData={usePayees}
      config={{
        ...moduleConfig,
        defaultTableDensity: 'compact',
        getColumns: (formatDate) => getColumns(formatDate),
        getToolbarIcon,
        getTableActions: (item, onDelete, _c, _ctx, opts) => getTableActions(item, onDelete, colors, undefined, opts),
      }}
    />
  );
};

export default List;
